var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('div',[_c('v-tabs',{attrs:{"color":_vm.themeInputColor,"dark":"","slider-color":"yellow","grow":""},model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},_vm._l((_vm.tabs),function(tab,i){return _c('v-tab',{key:i,staticClass:"px-3",attrs:{"href":'#tab-' + i,"ripple":false},on:{"click":function($event){return _vm.sendEvent(tab.name)}}},[_vm._v("\n\t\t\t\t"+_vm._s(tab.name)+"\n\t\t\t")])}),1),_c('v-tabs-items',{model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[_c('v-tab-item',{attrs:{"value":"tab-0"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"items":_vm.keysFilteration(
									Object.keys(
										_vm.totalData.total[0] || {}
									).sort(keyA => {
										if (
											this.priorityKeys.indexOf(
												keyA
											) !== -1
										) {
											return -1;
										}
										return 1;
									}),
									['daily', 'dau']
								),"hide-actions":true,"hide-headers":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',[_c('td',[_vm._v("\n\t\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.convertToReadableForm(
												props.item
											))+"\n\t\t\t\t\t\t\t\t\t")]),_c('td',[_vm._v("\n\t\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.totalData.total[0][
												props.item
											] || 0)+"\n\t\t\t\t\t\t\t\t\t")])])]}}])})],1)],1)],1),_c('v-tab-item',{attrs:{"value":"tab-1"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"items":_vm.keysFilteration(
									Object.keys(
										_vm.totalData.endDate[0] || {}
									).sort(keyA => {
										if (
											this.priorityKeys.indexOf(
												keyA
											) !== -1
										) {
											return -1;
										}
										return 1;
									}),
									['monthly', 'mau']
								),"hide-actions":true,"hide-headers":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',[_c('td',[_vm._v("\n\t\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.convertToReadableForm(
												props.item
											))+"\n\t\t\t\t\t\t\t\t\t")]),_c('td',[_vm._v("\n\t\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.totalData.endDate[0][
												props.item
											] || 0)+"\n\t\t\t\t\t\t\t\t\t")])])]}}])})],1)],1)],1)],1)],1),(_vm.isDataLoading)?_c('div',{staticClass:"overlay"},[_c('v-progress-circular',{attrs:{"indeterminate":true}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }